import React, { useState } from 'react';
import ReactTooltip from 'react-tooltip';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { generateCompStylers } from '../../common/utils/styles';
import { useTooltip } from './helpers';
import TooltipInfoModal from '../../widgets/tooltipInfoModal/TooltipModal';

const TooltipElement = ({
    children,
    text,
    modalText,
    place,
    className,
    compStyle,
    tooltipId,
    solid,
    showModalTooltip = true,
    disableOnMobile = true
}) => {
    const { stylers, classes } = generateCompStylers(compStyle);

    const [tooltipModal, showTooltipModal] = useState(false);

    const [isShowed, setIsShowed] = useState(false);
    const { attributes, id, simpleTooltip, tooltipAttributes } = useTooltip({ tooltipId, text, setIsShowed, disableOnMobile });

    if (!id) return null;

    return (
        <>
            <div
                className={classNames(classes.tooltipWrap, classes.tooltipWrapCustom)}
                style={{
                    ...stylers.tooltipWrap,
                    position: 'relative',
                    zIndex: 1,
                    ...stylers.tooltipWrapCustom
                }}
                onClick={() => {
                    if (modalText) {
                        showTooltipModal(true);
                    }
                }}
            >
                {id ? (
                    <>
                        <div
                            {...attributes}
                            style={{ ...stylers.inner, ...(isShowed ? stylers.innerShow : {}) }}
                            className={classNames(classes.inner, isShowed && classes.innerShow)}
                            data-class={`react-tooltip ${className || ''}`}
                            data-place={place}
                            // data-delay-hide={className && className.match(/react-tooltip-xl/gi) && mobile ? '100' : '0'}
                            {...(solid ? { 'data-effect': 'solid' } : {})}
                        >
                            {children}
                        </div>
                        {text && showModalTooltip ? (
                            className && className.match(/customPosition/gi) ? (
                                <ReactTooltip
                                    afterShow={() => {
                                        setIsShowed(true);
                                    }}
                                    afterHide={() => setIsShowed(false)}
                                    {...tooltipAttributes}
                                >
                                    {text}
                                </ReactTooltip>
                            ) : (
                                simpleTooltip
                            )
                        ) : null}
                    </>
                ) : null}
            </div>
            {tooltipModal ? <TooltipInfoModal text={modalText} closeHandler={() => showTooltipModal(false)} /> : null}
        </>
    );
};

TooltipElement.propTypes = {
    text: PropTypes.node,
    place: PropTypes.string,
    className: PropTypes.string
};

export default TooltipElement;
